<div class="footer">
  <div class="pull-right">
    {{ appName }}, Build {{ appVersion }}
  </div>
  <div>
    <span class="hidden-sm hidden-xs">Copyright &copy; 2017-2020</span>
  </div>
</div>